export const focusedNewMessagesRollupText = "Cngzje";
export const otherNewMessagesRollupText = "J9YPXb";
export default {focusedNewMessagesRollupText,otherNewMessagesRollupText};